/* eslint-disable react/no-array-index-key */
import { Card, Flex, Text } from '@library/uikit'
import { baseColors } from '@library/uikit/src/theme/colors'

import FoldableText from 'components/FoldableSection/FoldableText'
import { useTranslation } from '@library/localization'
import Image from 'next/image'
import styled from 'styled-components'
import igoQuestions from '../../../../../public/images/igos/igo_questions.png'
import config from './config'

const DetailsWrapper = styled.div`
  order: 1;
  margin-bottom: 40px;

  ${({ theme }) => theme.mediaQueries.md} {
    order: 2;
    margin-bottom: 0;
    margin-left: 40px;
  }
`

export const DetailFlex = styled(Flex)`
  flex-direction: column;
  position: relative;
  margin: 16px;
  background-color: ${() => baseColors.greyLine};
  padding: 31px;
  border-radius: 23px;
  font-size: 18px;
`

const IfoQuestions = () => {
  const { t } = useTranslation()

  return (
    <Flex alignItems={['center', null, null, 'start']} flexDirection={['column', null, null, 'row']}>
      <Card>
        <Image loading="lazy" src={igoQuestions} alt="igo pic" quality={40} width={400} height={350} />
      </Card>
      <DetailsWrapper>
        <Card withBorder>
          <Text fontWeight="bold" color="white" fontSize="22px" pt={36} pl={47}>
            {t('Details')}
          </Text>

          <DetailFlex>
            {config.map(({ title, description }, i, { length }) => {
              return (
                <FoldableText key={i} mb={i + 1 === length ? '' : '24px'} title={title}>
                  {description.map((desc, index) => {
                    return (
                      <Text key={index} color={baseColors.normal} fontSize="18px">
                        {desc}
                      </Text>
                    )
                  })}
                </FoldableText>
              )
            })}
          </DetailFlex>
        </Card>
      </DetailsWrapper>
    </Flex>
  )
}

export default IfoQuestions
